import FileUploadMultiple from "components/FileUploadMultiple";
import React from "react";
import { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { api } from "services";
import arrayAppend from 'helpers/array-append';

export default function AddFile({
  idAddFile, show, onHide, update
}){
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [invoiceNumber, setInvoiceNumber] = useState('');

  function submit(){
    let formData = new FormData();
    arrayAppend(formData, 'files', files);
    arrayAppend(formData, 'files_comments', filesComments);
    formData.append('invoice_number', invoiceNumber);
    api.post("expense-descriptions/add-file/"+idAddFile,formData).then(data=>{
      setFiles([]);
      setFilesComments([]);
      if(update)update();
    })
  }

  return(
    <Modal size="lg" show={show} onHide={onHide}>
      <Modal.Body>
        <Row>
          <Col xs="12">
            <Form.Group>
              <Form.Label>Número da nota fiscal</Form.Label>
              <Form.Control
                value={invoiceNumber}
                onChange={(e) => setInvoiceNumber(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col>
            <FileUploadMultiple
              files={files}
              setFiles={(files) => setFiles(files)}
              filesComments={filesComments}
              setFilesComments={(filesComments) =>
                setFilesComments(filesComments)
              }
              existingFiles={[]}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button size="sm" variant="danger" onClick={onHide}>
          Cancelar
        </Button>
        <Button size="sm" variant="success" onClick={()=>{
          onHide();
          submit();
        }}>
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}